import { NetsapiensCsp } from 'apis/agency/telephony/types';

export const EMPTY_NETSAPIENS_CSP: NetsapiensCsp = {
  csp_name: '',
  api_url: '',
  portal_url: '',
  client_id: '',
  client_secret: '',
  outbound_sip_uri: []
};

export function normalizeOutboundSipUris(value: unknown): string[] {
  if (Array.isArray(value)) {
    return value
      .flatMap((item) => String(item).split(','))
      .map((uri) => uri.trim())
      .filter(Boolean);
  }

  if (typeof value === 'string' && value.trim()) {
    return value
      .split(',')
      .map((uri) => uri.trim())
      .filter(Boolean);
  }

  return [];
}

export function formatOutboundSipUris(value?: string[] | string): string {
  return normalizeOutboundSipUris(value).join(', ');
}

export function normalizeCsps(value: unknown): NetsapiensCsp[] {
  if (!Array.isArray(value)) return [];

  return value.map((item) => ({
    csp_name: String(item?.csp_name ?? ''),
    api_url: String(item?.api_url ?? ''),
    portal_url: String(item?.portal_url ?? ''),
    client_id: String(item?.client_id ?? ''),
    client_secret: String(item?.client_secret ?? ''),
    outbound_sip_uri: normalizeOutboundSipUris(item?.outbound_sip_uri),
    code: item?.code ? String(item.code) : undefined,
    state: item?.state ? String(item.state) : undefined
  }));
}

export function mergeNetsapiensCsps(nextCsps: NetsapiensCsp[], existingCsps: NetsapiensCsp[] = []): NetsapiensCsp[] {
  return nextCsps.map((csp, index) => {
    const existing = existingCsps.find((entry) => entry.csp_name === csp.csp_name) || existingCsps[index];

    if (!existing) return csp;

    return {
      ...existing,
      ...csp,
      code: existing.code,
      state: existing.state
    };
  });
}

export function maskSecret(value?: string) {
  if (!value) return '—';
  if (value.length <= 8) return '••••••••';
  return `${value.slice(0, 8)}${'•'.repeat(Math.min(value.length - 8, 12))}`;
}
